// extracted by mini-css-extract-plugin
export default {"root":"ArdmNU","noReviews":"gIsftY","averageRating":"OP8MBt"};